import * as yup from "yup";

export const RA_EDIT_FORM_VALIDATION_SCHEMA = yup.object().shape({
    keylessArea: yup.object()
        .nullable()
        .required("common.error.required"),
});
